import { useEffect, useState } from "react";
import { levelMeta } from "../lib/scoring";

export function ScoreGauge({ value = 0, size = 200, label = true, testid }) {
  const [display, setDisplay] = useState(0);
  const meta = levelMeta(value);
  const stroke = 14;
  const r = (size - stroke) / 2;
  const c = 2 * Math.PI * r;
  const pct = Math.max(0, Math.min(100, value)) / 100;

  useEffect(() => {
    let raf;
    const start = performance.now();
    const dur = 900;
    const tick = (now) => {
      const p = Math.min(1, (now - start) / dur);
      const eased = 1 - Math.pow(1 - p, 3);
      setDisplay(Math.round(value * eased));
      if (p < 1) raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [value]);

  return (
    <div className="relative inline-grid place-items-center" data-testid={testid} style={{ width: size, height: size }}>
      <svg width={size} height={size} className="-rotate-90">
        <circle cx={size / 2} cy={size / 2} r={r} fill="none" stroke="#E2E8F0" strokeWidth={stroke} />
        <circle
          cx={size / 2} cy={size / 2} r={r} fill="none" stroke={meta.color} strokeWidth={stroke}
          strokeLinecap="round" strokeDasharray={c}
          strokeDashoffset={c * (1 - pct)}
          style={{ transition: "stroke-dashoffset 0.9s cubic-bezier(0.16,1,0.3,1)" }}
        />
      </svg>
      <div className="absolute inset-0 grid place-items-center text-center">
        <div>
          <div className="num font-bold text-ink leading-none" style={{ fontSize: size * 0.26 }}>
            {display}
          </div>
          <div className="text-ink-faint text-xs mt-1 num">/ 100</div>
          {label && (
            <div className="mt-2 text-[11px] font-semibold px-2.5 py-1 rounded-full inline-block"
                 style={{ background: meta.bg, color: meta.text }}>
              {meta.label}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
